import { saveAs } from 'file-saver'; // https://github.com/eligrey/FileSaver.js
import React from 'react';
import { createFaviconsArchive } from '../../domain/zip-provider';
import { useAppSelector } from '../../data/store';

const DownloadButton = () => {

    const randomIcon = useAppSelector(store => store.root.randomIcon);

    // form properties from redux store
    const strokeWidth = useAppSelector(store => store.form.strokeWidth);
    const strokeColor = useAppSelector(store => store.form.strokeColor);
    const hasStroke = useAppSelector(store => store.form.hasStroke);

    const fillColor = useAppSelector(store => store.form.fillColor);
    const hasFill = useAppSelector(store => store.form.hasFill);

    const backgroundColor = useAppSelector(store => store.form.backgroundColor);
    const backgroundType = useAppSelector(store => store.form.backgroundType);

    const rotation = useAppSelector(store => store.form.rotation);
    const scale = useAppSelector(store => store.form.scale);

    const sharpness = useAppSelector(store => store.form.sharpness);
    const smoothness = useAppSelector(store => store.form.smoothness);

    /**
     * download a zip archive with favicons
     */
    const downloadHandler = async () => {

        if(!randomIcon) return;

        const zipBlob = await createFaviconsArchive(
            randomIcon.svg,
            strokeWidth,
            strokeColor,
            hasStroke,

            fillColor,
            hasFill,

            backgroundType,
            backgroundColor,

            rotation,
            scale,

            sharpness,
            smoothness
        );
        if(!zipBlob) return;

        saveAs(zipBlob, 'favicons.zip');

        // scroll to 'instructions' section
        const $instructions = document.getElementById('instructions');
        if(!$instructions) return;

        $instructions.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    };

    return (
        <button
            type="button"
            className="bg-gray-500 hover:bg-gray-600 text-gray-100 rounded-full px-12 py-3 text-xl whitespace-nowrap transition duration-150 ease-out hover:ease-in"
            onClick={ downloadHandler }>Download</button>
    )
};

export default DownloadButton;